import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Ipd = () => {
  return (
    <section id="ipd-management" className="landing ipd-landing">
      <Helmet>
        <title>IPD Management Software India — Mediway Nextgen</title>
        <meta name="description" content="IPD management for hospitals in India — bed management, nursing workflows, admission/discharge, clinical documentation and integrated billing." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/services/ipd-management-software" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            'name': 'IPD Management Software',
            'description': 'IPD management with bed allocation, nursing workflows, admission/discharge processes and integrated billing for hospitals in India.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/services/ipd-management-software'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">IPD Management — Improve Inpatient Care</h2>
          <p className="section-subtitle">Bed management, nursing workflows, clinical documentation and integrated IPD billing for Indian hospitals and multi‑location networks.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🛏️</div>
            <div className="service-info">
              <h3 className="service-title">Streamlined Inpatient Care</h3>
              <p className="service-description">Bed allocation, nursing workflows and clinical documentation to improve throughput and clinical safety across wards and specialty units.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Core Capabilities</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Bed allocation &amp; occupancy tracking</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Nursing tasklists &amp; care plans</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Integrated IPD billing &amp; claims exports</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Discharge summaries &amp; follow-up scheduling</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">🏥</div><span>Improve bed utilization</span></div>
                <div className="benefit-card"><div className="benefit-icon">👩‍⚕️</div><span>Increase nursing efficiency</span></div>
                <div className="benefit-card"><div className="benefit-icon">💳</div><span>Simplify billing & claims</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Request IPD Demo</Link>
            <Link to="/services" className="btn btn-secondary">All Services</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default Ipd;